import { render, staticRenderFns } from "./UpgradeToGoldPrompt.vue?vue&type=template&id=16c43b08&"
import script from "./UpgradeToGoldPrompt.vue?vue&type=script&lang=js&"
export * from "./UpgradeToGoldPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports